import {universignTransactionStatus} from '../../utils/constant';

export default class FakeSignatureService {
  signDocument(documentId) {
    return Promise.resolve({documentId});
  }

  sendSignedDocument(transactionId) {
    return Promise.resolve({
      id: transactionId,
      url: `https://sign.test.universign.eu/sig/#/?id=${transactionId}`,
      status: universignTransactionStatus.COMPLETED
    });
  }
}
